<template>
  <div class="interview-sheet renew2_wrapper">
    <div class="interview-sheet-header">
      <h3>面接よくある15選 \模範解答付き/</h3>
      <!-- <div v-if="!isLoading" class="add-question">
        <button @click="addMoreQuestion(newQuestion)">質問を増やす</button>
      </div> -->
    </div>

    <div v-if="isLoading" class="loading-container" ref="addQuestionButton">
      <div class="loading-spinner"></div>
      <p>質問を取得中...<br>初回取得時は時間がかかることがあります。</p>
    </div>
    
    <ul v-else>
      <li v-for="(question, index) in questions" :key="index" class="question-item">
        <details class="question-accordion">
          <summary class="question-text">
            <div class="question-head">
              <p class="question-title">Q. {{ question.question }}</p>
              <div class="toggle_button"></div>
            </div>
          </summary>
          <!-- アコーディオンでanswerを表示する -->
          <p class="question-answer">A. 【例文】 {{ question.answer }}</p>
        </details>
      </li>
    </ul>

  </div>
</template>

<script>
export default {
  name: 'InterviewSheet',
  props: {
    companyInfo: {
      type: String,
      required: true
    },
    motivation: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      questions: {},
      newQuestion: '',
      isLoading: true
    };
  },
  async created() {
    try {
      const response = await this.$axios.post(this.$varuna.endPoints.aiInterviewSheet, {
        uuid: this.$firebase.user.uid,
        companyInfo: this.companyInfo,
        reason: this.motivation,
      });
      this.questions = await response.data.questions;
    } catch (error) {
      console.error('Error fetching interview sheet:', error);
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    addQuestion(newQuestion) {
      if (!newQuestion) return;
      this.questions.push(newQuestion);
      this.newQuestion = '';
    },
    async addMoreQuestion() {
      this.isLoading = true;
        this.scrollToButton();
      try {
        const response = await this.$axios.post(this.$varuna.endPoints.addQuestion, {
          uuid: this.$firebase.user.uid,
          companyInfo: this.companyInfo,
          reason: this.motivation,
        });
        this.questions = await response.data.questions;
      } catch (error) {
        console.error('Error adding more questions:', error);
      } finally {
        this.isLoading = false;
      }
    },
    scrollToButton() {
      this.$nextTick(() => {
        this.$refs.addQuestionButton.scrollIntoView({ behavior: 'smooth' });
      });
    }
  }
};
</script>

<style scoped>
.interview-sheet-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.loading-container {
  text-align: center;
  margin-top: 20px;
}
.loading-spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.question-item {
  padding: 18px 8px 10px;
  border-bottom: 1px solid #e0e0e0;
  flex-wrap: nowrap;
}
.question-text {
  padding-bottom: 10px;
  display: block;
}
.question-head {
  display: flex; /* Flexboxを使用 */
  align-items: center; /* 垂直方向に中央揃え */
  justify-content: space-between; /* 必要に応じて左端と右端に要素を配置 */
  list-style: none;
}
.question-text::-webkit-details-marker {
  display: none;
}
.question-accordion[open] .question-answer {
  animation: fadeIn 0.85s ease;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(-12px);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
.question-answer {
  padding: 8px;
}
.question-title {
  position: relative;
  padding-right: 30px;
}
.toggle_button {
  display: block;
  position: relative;
  width: 20px;
  margin-left: auto;
  flex-shrink: 0;
  transform-origin: center 45%;
  transition: transform 0.75s;
}
.toggle_button::before,
.toggle_button::after {
  content: "";
  position: absolute;
  display: block;
  width: 12px;
  height: 2px;
  background-color: #763f49;
}
.toggle_button::before {
  left: 0;
  transform: rotate(45deg);
}
.toggle_button::after {
  right: 0;
  transform: rotate(-45deg);
}
/* 三角ボタン切り替え */
details[open] .toggle_button {
  transform: rotate(180deg);
}
.remove-button {
  background-color: #e74c3c;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  white-space: nowrap;
}
.remove-button:hover {
  background-color: #c0392b;
}
.add-question {
  display: flex;
}
.add-question input {
  flex: 1;
  padding: 8px;
  margin-right: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.add-question button {
  padding: 8px 16px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.add-question button:disabled {
  background-color: #95a5a6;
  cursor: not-allowed;
}
</style>